import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { analyticsService } from '../lib/analytics/analyticsService';
import { sessionTracker } from '../lib/analytics/sessionTracker';
import { logger } from '../lib/logger';
import { useHotelConfig } from '../hooks/useHotelConfig';

export const AnalyticsRouteTracker: React.FC = () => {
  const location = useLocation();
  const { id: hotelId, slug, baseUrl } = useHotelConfig();

  useEffect(() => {
    // Track page view on route change
    analyticsService.trackEvent({
      event_type: 'navigation',
      event_name: 'page_view',
      event_data: {
        path: location.pathname,
        page_title: document.title,
        query_params: location.search,
        hash: location.hash,
        hotel_id: hotelId,
        hotel_slug: slug,
        base_url: baseUrl,
        timestamp: new Date().toISOString()
      }
    });

    // Increment page view in session tracker
    sessionTracker.incrementPageView();

    logger.debug('Page view tracked', {
      category: 'Analytics',
      data: {
        path: location.pathname,
        title: document.title,
        hotelId,
        slug,
        baseUrl,
        timestamp: new Date().toISOString()
      }
    });
  }, [location.pathname, location.search, location.hash, hotelId, slug, baseUrl]);

  return null;
};